/**
 * Extracts query parameters from the currently executing <script> src URL.
 * Prefers a tagged script element and falls back to known src patterns.
 *
 * @returns {{ campaignId: string|null, organizationId: string|null, preview: boolean, configSource: 'Api'|'Local'|'Auto' }}
 */
export function parseScriptParams() {
  const currentScript = document.currentScript;
  const taggedScript = document.querySelector('script[data-tm-script="acquisition-form"][src]');
  const scriptUrl = currentScript?.src || taggedScript?.src || null;

  if (!scriptUrl) {
    return { campaignId: null, organizationId: null, preview: false, configSource: 'Auto' };
  }

  try {
    const url = new URL(scriptUrl);
    const previewValue = url.searchParams.get('tm-preview');
    const preview = previewValue === 'true' || previewValue === '1';
    const configSourceParam = url.searchParams.get('tm-config-source') || '';
    const configSource = ['Api', 'Local', 'Auto'].includes(configSourceParam)
      ? configSourceParam
      : 'Auto';

    return {
      campaignId: url.searchParams.get('tm-campaign-id') || null,
      organizationId: url.searchParams.get('tm-organization-id') || null,
      preview,
      configSource
    };
  } catch {
    return { campaignId: null, organizationId: null, preview: false, configSource: 'Auto' };
  }
}
